import { useState } from "react";
import { Button } from "react-bootstrap";
import * as API from "../services/API";

export default function GalerieCategoryName({ category, onRenamed }) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(category.name);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const save = (event) => {
    event.preventDefault();
    if (saving || !name.trim()) return;
    setSaving(true);
    setError("");
    API.renameGalerieCategoryRequest({ _id: category._id, name: name.trim() },
      (response) => {
        onRenamed(response.data);
        setSaving(false);
        setEditing(false);
      },
      (message) => {
        setSaving(false);
        setError(message);
      }
    );
  };

  if (!editing) return <>
    <strong>{category.name}</strong>
    <Button size="sm" variant="outline-primary" className="ms-2"
      aria-label={`Renommer ${category.name}`}
      onClick={() => { setName(category.name); setError(""); setEditing(true); }}>
      Renommer
    </Button>
  </>;

  return <form onSubmit={save} className="me-3">
    <label htmlFor={`category-name-${category._id}`} className="form-label">Nom de la catégorie</label>
    <input id={`category-name-${category._id}`} className="form-control" autoFocus
      value={name} disabled={saving} onChange={(event) => setName(event.target.value)} />
    {error && <div role="alert" className="text-danger mt-2">{error}</div>}
    <div className="d-flex flex-wrap gap-2 mt-2">
      <Button size="sm" type="submit" disabled={saving || !name.trim() || name.trim() === category.name}>
        {saving ? "Enregistrement…" : "Enregistrer"}
      </Button>
      <Button size="sm" variant="secondary" disabled={saving} onClick={() => setEditing(false)}>Annuler</Button>
    </div>
  </form>;
}
